import { render, staticRenderFns } from "./AQIChartComponent.vue?vue&type=template&id=3d7567c0"
import script from "./AQIChartComponent.vue?vue&type=script&lang=js"
export * from "./AQIChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports